import { useLanguage } from "@/contexts/LanguageContext";

export function StudioHeaderTitle() {
  const { t } = useLanguage();

  // <h2>, not <h1>: this is a shared studio-chrome label repeated on every
  // flow page. The page's single <h1> is the per-flow hero (or the sr-only
  // heading injected by StudioPageLayout for hero-less flows).
  return (
    <h2 className="text-base md:text-lg font-bold text-foreground text-center mb-3 md:mb-3.5">
      {t.generate.creativeStudio}
    </h2>
  );
}
